export const StreamType = [
  {text: 'Онлайн трансляция 2D', value: 'FLAT_VIDEO', disable: false},
  {text: 'Трансляция в виртуальной реальности', value: 'VR_VIDEO', disable: false},
  {text: 'VR_SPACE', value: 'VR_SPACE', disable: true},
  {text: 'TELEPRESENT_FLAT', value: 'TELEPRESENT_FLAT', disable: true},
  {text: 'TELEPRESENT_VR', value: 'TELEPRESENT_VR', disable: true},
]
